export default "__VITE_ASSET__DRSXFirO__"